<template>
  <div class="flex a-center">
    <a-cascader v-model="sValue" :field-names="{label:'name',value:'code',children: 'children'}" :options="regions" placeholder="请选择省市区" />
    <a-input
      v-if="addrDetail"
      v-model="addressDetail"
      placeholder="详细地址"
    />
  </div>
</template>
<script>
import regions from '@/common/agency'
export default {
  props: {
    result: {
      type: Object,
      default: null
    },
    addrDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      regions: regions,
      addressDetail: null,
      sValue: null
    }
  },
  watch: {
    // sValue(n) {
    //   console.log(n)
    // },
    result(n) {
      this.setResult(n)
    },
    sValue(n) {
      this.$emit('update:result', this.val2obj(n))
      this.$nextTick(() => {
        this.$emit('change')
      })
    },
    addressDetail() {
      this.$emit('update:result', this.val2obj(this.sValue))
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  },
  created() {
    if (this.result) {
      this.setResult(this.result)
    }
  },
  methods: {
    setResult(n) {
      if (!this.sValue && n) {
        this.sValue = [n.provinceCode, n.cityCode, n.areaCode]
        this.addressDetail = n.addressDetail
      } else if (this.sValue && n && (n.provinceCode !== this.sValue[0] || n.cityCode !== this.sValue[1] || n.areaCode !== this.sValue[2] || this.addressDetail !== n.addressDetail)) {
        this.sValue = [n.provinceCode, n.cityCode, n.areaCode]
        this.addressDetail = n.addressDetail
      } else if (!n) {
        this.sValue = null
        this.addressDetail = null
      }
    },
    val2obj(sValue) {
      if (!sValue || sValue && sValue.length === 0) {
        return null
      }
      const provinceCode = sValue[0]
      const cityCode = sValue[1]
      const areaCode = sValue[2]
      const result = {}
      const p = this.regions.find(el => el.code === provinceCode)
      if (p) {
        result.provinceCode = p.code
        result.provinceName = p.name
        if (p && p.children) {
          const c = p.children.find(el => el.code === cityCode)
          if (c) {
            result.cityCode = c.code
            result.cityName = c.name
          }
          if (c && c.children) {
            const a = c.children.find(el => el.code === areaCode)
            if (a) {
              result.areaCode = a.code
              result.areaName = a.name
            }
          }
        }
      }
      result.addressDetail = this.addressDetail
      return result
    }

  }
}
</script>
